import {
  type MaintenanceChecklistSection,
  type MaintenanceProtocolEditor,
  validateMaintenanceProtocolCompleteness,
} from '@gb-ticket/shared-types';

export function buildProtocolAnswerRows(
  editor: MaintenanceProtocolEditor,
  localValues: Record<string, unknown>,
): { fieldKey: string; value: unknown }[] {
  const keys = new Set<string>([
    ...editor.answers.map((a) => a.fieldKey),
    ...Object.keys(localValues),
  ]);
  const answerByKey = new Map(editor.answers.map((a) => [a.fieldKey, a.value]));
  return [...keys].map((fieldKey) => ({
    fieldKey,
    value: fieldKey in localValues ? localValues[fieldKey] : answerByKey.get(fieldKey),
  }));
}

export function protocolSectionIsComplete(
  section: MaintenanceChecklistSection,
  editor: MaintenanceProtocolEditor,
  localValues: Record<string, unknown>,
): boolean {
  const answers = buildProtocolAnswerRows(editor, localValues);
  const attachments = editor.attachments.map((a) => ({
    id: a.id,
    fieldKey: a.fieldKey,
    scanStatus: a.scanStatus,
  }));
  const issues = validateMaintenanceProtocolCompleteness(
    editor.templateSnapshot,
    answers,
    attachments,
  ).issues;
  const fieldKeys = new Set(section.fields.map((f) => f.fieldKey));
  return !issues.some((issue) => fieldKeys.has(issue.fieldKey));
}
